export default __webpack_public_path__ + "static/media/ErrorIcon.f013d031.svg";